import Apollo from '@adoratorio/apollo';
import engine from './engine';

const apollo = {
  ref: null,

  init() {
    this.ref = new Apollo({
      cursor: document.querySelector('.cursor'),
      easing: {
        mode: Apollo.EASING.CUBIC,
        duration: 600,
      },
      props: [],
      targets: [],
      aion: engine,
    });
  },
};

export default apollo;
